import React from 'react'
import { TouchableOpacity, View, ViewStyle } from 'react-native'
import { Text } from '../text'
import { Medallion } from '../medallion'
import { Label } from '../label'
import { useTranslation } from 'react-i18next'
const _snakeCase = require('lodash/snakeCase')

interface CertificationCardProps {
  certification: string
  recall: number | null | undefined
  title: string
  style?: ViewStyle
  onPress?: () => void
}
export const CertificationCard = (props: CertificationCardProps) => {
  const { certification, style, recall, onPress, title } = props

  const renderLabelColor = () => {
    switch (certification) {
      case 'Platinum':
        return { background: '#F7F7F7', text: '#9699B5' }
      case 'Gold':
        return { background: '#ECAF1710', text: '#EDB552' }
      case 'Silver':
        return { background: '#10101010', text: '#778390' }
      case 'Bronze':
        return { background: '#8D775820', text: '#8D7758' }
      default:
        return { background: '#ffffff', text: '#000000' }
    }
  }

  const { t } = useTranslation()

  const levelTx = t(`Certifications.${certification?.toLowerCase()}`)

  return (
    <TouchableOpacity
      // @ts-ignore
      dataSet={{ qat: `${_snakeCase(title)}_cert` }}
      onPress={onPress}
      style={{ ...ROOT, ...style }}
    >
      <View style={CONTAINER}>
        <Medallion
          style={{ position: 'absolute', top: -36 }}
          type={certification}
          recall={recall}
          scale={0.37}
        />
        <View style={SPACER} />
        <View style={TITLE}>
          <Text
            numberOfLines={2}
            style={{ textAlign: 'center' }}
            text={title}
            variant="body1Emphasized"
          />
        </View>
        <View style={LABEL}>
          <Label
            labelColor={renderLabelColor()}
            labelTx="Certifications.complete_cert"
            txOptions={{ level: certification !== null ? levelTx : '' }}
          />
        </View>
      </View>
    </TouchableOpacity>
  )
}

const ROOT: ViewStyle = {
  height: 153,
  width: 146,
  shadowOffset: { height: 0, width: 0 },
  borderWidth: 2,
  borderColor: '#F3F2F1',
  borderRadius: 20,
  backgroundColor: '#fff',
  padding: 16,
}
const CONTAINER: ViewStyle = { flexDirection: 'column', display: 'flex', flex: 1 }
const SPACER: ViewStyle = { display: 'flex', flex: 1 }
const TITLE: ViewStyle = {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  flexDirection: 'column',
}
const LABEL: ViewStyle = {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  top: 8,
}
